import './card-office.scss';

export default () => {
};
